import React, { useEffect, useRef, useState } from "react";

interface ScrollProgressProps {
  target: number;
  speed?: number;
  isStart: boolean;
}

export const OdoMeter: React.FC<ScrollProgressProps> = ({ target, speed = 20, isStart }) => {
  const [value, setValue] = useState(0);
  const [visible, setVisible] = useState(false);
  const [started, setStarted] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!started || !visible) return;

    const interval = setInterval(() => {
      setValue((prev) => {
        const next = Math.min(prev + 0.5, target);
        if (next >= target) clearInterval(interval);
        return next;
      });
    }, speed);

    return () => clearInterval(interval);
  }, [started, visible, target, speed]);

  const handleStart = () => {
    if (value < target) setStarted(true);
  };

  const handleReset = () => {
    setStarted(false);
    setValue(0);
  };

  useEffect(() => {
    handleStart();
    if (isStart) {
      handleStart();
    } else {
      handleReset();
    }
  }, [isStart]);

  return (
    <div style={{ transition: "0.4s all" }} ref={ref}>
      {value.toFixed(1)}%
    </div>
  );
};
